import { BsInfo, BsMenuApp } from "react-icons/bs";
import Metronome from "./Metronome";
import ModalButton from "./ModalButton";
import EasyPadsHeader from "./Info";
import { useStorePads } from "../store";

export default function Header() {
    const toggleSetList = useStorePads((state) => state.toggleSetList)

    return (
        <header className="w-full py-2 px-2 bg-neutral-900 shadow-md flex justify-between items-center relative">
            <picture className="w-10">
                <img src="/logo.svg" alt="easypads" />
            </picture>
            <div className="flex items-center">
                <Metronome />
            </div>
            <div className="flex items-center gap-2">
                <button onClick={toggleSetList}>
                    <BsMenuApp size={24} />
                </button>
                <ModalButton
                    buttonContent={<BsInfo size={24} />}
                    position="top"
                >
                    <EasyPadsHeader />
                </ModalButton>
            </div>
        </header>
    )
}
